import React from 'react';

class ProfileMgr extends React.Component {
  render() {
    return <div className='dms-body'>
      {this.props.children}
    </div>
  }
};
export default ProfileMgr;


// WEBPACK FOOTER //
// ./src/routes/profile/index.js